var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMansionIcon = function SvgMansionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mansion_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.484 1.106H3.552v71.697h41.932V1.106Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.787 73.104H3.25V.802h42.538v72.302Zm-41.931-.608H45.18V1.41H3.856v71.086Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.408 67.667H3.631V72.8h41.777v-5.133Z",
    fill: "#545252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.712 73.103H3.337v-5.74h42.374v5.74Zm-41.768-.607h41.16V67.97H3.945v4.525Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.837 62.32H13.2v10.656h22.637V62.319Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.14 73.283H12.896V62.015H36.14v11.268Zm-22.637-.608h22.03V62.623h-22.03v10.052Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.734 62.78h-.428V72.98h.428V62.78Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.067 61.395H12.972v1.453h23.095v-1.453Z",
    fill: "#585555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.22 62.996h-23.4v-1.753h23.4v1.753Zm-23.096-.303h22.792v-1.146H13.124v1.146Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.058 71.417h-23.08v1.036h23.08v-1.036Z",
    fill: "#6A6868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.21 72.605H12.826v-1.34H36.21v1.34Zm-23.08-.304h22.777v-.732H13.13v.732Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.59 72.207H12.45v1.036h24.14v-1.036Z",
    fill: "#6A6868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.74 73.392H12.3v-1.337H36.74v1.337Zm-24.138-.304h23.835v-.729H12.602v.73Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.414 63.878h-.82v9.305h.82v-9.305Z",
    fill: "#CDA082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.566 73.334h-1.123v-9.608h1.123v9.608Zm-.82-.303h.516V64.03h-.516v9Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.513 66.427a1.336 1.336 0 0 0-.634-1.133 1.268 1.268 0 0 0-.091-1.647 1.276 1.276 0 0 0-.861-.395 1.04 1.04 0 0 0-1.125-.71 1.038 1.038 0 0 0-.899.98 1.516 1.516 0 0 0-1.07 1.758c.05.247.16.479.32.673a1.328 1.328 0 0 0 .768 2.383 1.33 1.33 0 0 0 1.466.95 1.328 1.328 0 0 0 1.116-1.57 1.328 1.328 0 0 0 1.01-1.289Z",
    fill: "#ABCD56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.192 69.454a1.49 1.49 0 0 1-1.386-.972 1.472 1.472 0 0 1-1.25-.996 1.48 1.48 0 0 1 .389-1.55 1.658 1.658 0 0 1-.001-1.912 1.67 1.67 0 0 1 .804-.614 1.192 1.192 0 0 1 1.022-1.024 1.188 1.188 0 0 1 1.254.72 1.431 1.431 0 0 1 1.259 1.42c0 .255-.07.507-.204.725a1.48 1.48 0 0 1-.421 2.574c.003.046.003.091 0 .137a1.49 1.49 0 0 1-1.466 1.492Zm-.257-6.773a.882.882 0 0 0-.883.847v.11l-.103.03a1.37 1.37 0 0 0-.962 1.587c.044.223.143.432.288.607l.097.122-.121.094a1.176 1.176 0 0 0 .68 2.109h.109l.03.106a1.173 1.173 0 0 0 1.963.506 1.186 1.186 0 0 0 .324-1.056l-.027-.14.14-.033a1.177 1.177 0 0 0 .788-1.638 1.177 1.177 0 0 0-.452-.51l-.142-.089.1-.133c.148-.194.23-.43.23-.675a1.131 1.131 0 0 0-1.074-1.124h-.103l-.033-.1a.885.885 0 0 0-.85-.62Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.854 62.605h-.931v10.578h.931V62.605Z",
    fill: "#CDA082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.006 73.335H44.77V62.453h1.235v10.882Zm-.932-.304h.628V62.756h-.628v10.275Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.236 65.504a1.521 1.521 0 0 0-.722-1.289 1.448 1.448 0 0 0-1.087-2.321 1.181 1.181 0 0 0-1.992-.44 1.183 1.183 0 0 0-.31.743 1.75 1.75 0 0 0-1.244 1.784c.015.261.089.516.215.745a1.52 1.52 0 0 0 .986 2.54 1.52 1.52 0 0 0 1.517 1.52 1.516 1.516 0 0 0 1.49-1.802 1.516 1.516 0 0 0 1.147-1.48Z",
    fill: "#8AC259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.602 68.922a1.67 1.67 0 0 1-1.66-1.52 1.656 1.656 0 0 1-1.382-1.913 1.66 1.66 0 0 1 .36-.788 1.895 1.895 0 0 1 .161-1.92c.225-.32.543-.562.91-.696a1.331 1.331 0 0 1 1.991-.98c.254.149.451.378.56.652a1.598 1.598 0 0 1 1.187 2.425 1.659 1.659 0 0 1-.47 2.905c.003.057.003.113 0 .17a1.673 1.673 0 0 1-1.657 1.665Zm-.303-7.7a1.03 1.03 0 0 0-1.029.978v.095l-.103.03a1.597 1.597 0 0 0-.94 2.306l.055.098-.076.082a1.356 1.356 0 0 0 .886 2.285h.139v.14a1.369 1.369 0 0 0 1.365 1.367 1.364 1.364 0 0 0 1.338-1.62l-.024-.14.14-.036a1.355 1.355 0 0 0 1.02-1.11 1.36 1.36 0 0 0-.632-1.37l-.143-.084.1-.134a1.296 1.296 0 0 0-.974-2.079h-.103l-.033-.1a1.03 1.03 0 0 0-.974-.708h-.012Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.923 62.605H2.99v10.578h.932V62.605Z",
    fill: "#CDA082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.074 73.335H2.84V62.453h1.234v10.882Zm-.931-.304h.628V62.756h-.628v10.275Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31 65.504a1.522 1.522 0 0 0-.722-1.289 1.448 1.448 0 0 0-1.086-2.321 1.179 1.179 0 0 0-1.277-.817 1.177 1.177 0 0 0-1.023 1.12 1.747 1.747 0 0 0-1.217 2.01c.055.283.178.547.359.771a1.52 1.52 0 0 0 .88 2.705 1.519 1.519 0 0 0 1.658 1.04 1.516 1.516 0 0 0 1.303-1.463 1.716 1.716 0 0 0-.028-.282 1.517 1.517 0 0 0 1.153-1.474Z",
    fill: "#8AC259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.67 68.922a1.673 1.673 0 0 1-1.546-1.103 1.655 1.655 0 0 1-1.416-1.118 1.662 1.662 0 0 1 .442-1.75 1.904 1.904 0 0 1 .91-2.872 1.332 1.332 0 0 1 1.149-1.153 1.327 1.327 0 0 1 1.402.825 1.598 1.598 0 0 1 1.423 1.592c0 .294-.08.582-.234.833a1.662 1.662 0 0 1-.473 2.905c.003.056.003.113 0 .17a1.673 1.673 0 0 1-1.656 1.671Zm-.303-7.7a1.03 1.03 0 0 0-1.028.978v.095l-.103.03a1.595 1.595 0 0 0-1.111 1.837c.05.258.163.5.328.703l.097.119-.121.097a1.355 1.355 0 0 0 .789 2.431h.112l.03.107a1.352 1.352 0 0 0 2.265.583c.255-.257.399-.604.399-.966a1.327 1.327 0 0 0-.028-.252l-.024-.14.14-.037a1.355 1.355 0 0 0 1.021-1.11 1.36 1.36 0 0 0-.633-1.37l-.143-.084.104-.125a1.296 1.296 0 0 0-.974-2.078h-.103l-.034-.1a1.027 1.027 0 0 0-.97-.718h-.013ZM36.835 55.694V2.578h-.4v53.117h.4ZM28.605 55.694V2.578h-.4v53.117h.4ZM20.878 55.694V2.578h-.4v53.117h.4ZM12.802 55.694V2.578h-.4v53.117h.4Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.387 5.686H6.271v2.877h4.116V5.686Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.688 8.867h-4.72V5.382h4.72v3.485ZM6.574 8.26h3.507V5.99H6.574v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.915 5.686h-4.117v2.877h4.117V5.686Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.215 8.867h-4.72V5.382h4.72v3.485Zm-4.113-.608h3.507V5.99h-3.507v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.833 5.686h-4.117v2.877h4.117V5.686Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.136 8.867h-4.723V5.382h4.723v3.485ZM23.02 8.26h3.51V5.99h-3.51v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.499 5.686h-4.117v2.877H34.5V5.686Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8 8.867h-4.721V5.382h4.72v3.485Zm-4.114-.608h3.507V5.99h-3.507v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.027 5.686H38.91v2.877h4.117V5.686Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.327 8.867h-4.72V5.382h4.72v3.485Zm-4.114-.608h3.507V5.99h-3.507v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.757 8.469H3.282v4.124h42.475V8.469Z",
    fill: "#585555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.06 12.896H2.98V8.165h43.077l.003 4.731ZM3.59 12.29h41.865V8.773H3.589v3.516Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.387 15.018H6.271v2.877h4.116v-2.877Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.688 18.2h-4.72v-3.486h4.72v3.485Zm-4.114-.609h3.507v-2.27H6.574v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.915 15.018h-4.117v2.877h4.117v-2.877Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.215 18.2h-4.72v-3.486h4.72v3.485Zm-4.113-.609h3.507v-2.27h-3.507v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.833 15.018h-4.117v2.877h4.117v-2.877Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.136 18.2h-4.723v-3.486h4.723v3.485Zm-4.116-.609h3.51v-2.27h-3.51v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.754 15.018h-4.117v2.877h4.117v-2.877Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.057 18.2h-4.72v-3.486h4.723l-.003 3.485Zm-4.117-.609h3.51v-2.27h-3.507l-.003 2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.282 15.018h-4.117v2.877h4.117v-2.877Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.585 18.2H38.86v-3.486h4.724v3.485Zm-4.117-.609h3.51v-2.27h-3.51v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.757 17.804H3.282v4.124h42.475v-4.124Z",
    fill: "#585555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.06 22.232H2.98V17.5h43.077l.003 4.732ZM3.59 21.624h41.865v-3.516H3.589v3.516Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.387 24.352H6.271v2.878h4.116v-2.878Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.688 27.534h-4.72V24.05h4.72v3.485Zm-4.114-.607h3.507v-2.27H6.574v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.915 24.352h-4.117v2.878h4.117v-2.878Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.215 27.534h-4.72V24.05h4.72v3.485Zm-4.113-.607h3.507v-2.27h-3.507v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.833 24.352h-4.117v2.878h4.117v-2.878Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.136 27.534h-4.723V24.05h4.723v3.485Zm-4.116-.607h3.51v-2.27h-3.51v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.754 24.352h-4.117v2.878h4.117v-2.878Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.057 27.534h-4.72V24.05h4.723l-.003 3.485Zm-4.117-.607h3.51v-2.27h-3.507l-.003 2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.282 24.352h-4.117v2.878h4.117v-2.878Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.585 27.534H38.86V24.05h4.724v3.485Zm-4.117-.607h3.51v-2.27h-3.51v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.757 27.14H3.282v4.123h42.475v-4.124Z",
    fill: "#585555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.06 31.564H2.98v-4.729h43.077l.003 4.729ZM3.59 30.956h41.865v-3.513H3.589v3.513Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.387 33.685H6.271v2.877h4.116v-2.877Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.688 36.866h-4.72v-3.485h4.72v3.485Zm-4.114-.607h3.507v-2.27H6.574v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.915 33.685h-4.117v2.877h4.117v-2.877Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.215 36.866h-4.72v-3.485h4.72v3.485Zm-4.113-.607h3.507v-2.27h-3.507v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.833 33.685h-4.117v2.877h4.117v-2.877Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.136 36.866h-4.723v-3.485h4.723v3.485Zm-4.116-.607h3.51v-2.27h-3.51v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.754 33.685h-4.117v2.877h4.117v-2.877Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.057 36.866h-4.72v-3.485h4.723l-.003 3.485Zm-4.117-.607h3.51v-2.27h-3.507l-.003 2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.282 33.685h-4.117v2.877h4.117v-2.877Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.585 36.866H38.86v-3.485h4.724v3.485Zm-4.117-.607h3.51v-2.27h-3.51v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.757 36.471H3.282v4.124h42.475V36.47Z",
    fill: "#585555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.06 40.899H2.98V36.16h43.077l.003 4.738ZM3.59 40.29h41.865V36.77H3.589v3.522Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.387 43.02H6.271v2.877h4.116V43.02Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.688 46.19h-4.72v-3.474h4.72v3.473Zm-4.114-.609h3.507v-2.27H6.574v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.915 43.02h-4.117v2.877h4.117V43.02Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.215 46.19h-4.72v-3.474h4.72v3.473Zm-4.113-.609h3.507v-2.27h-3.507v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.833 43.02h-4.117v2.877h4.117V43.02Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.136 46.19h-4.723v-3.474h4.723v3.473Zm-4.116-.609h3.51v-2.27h-3.51v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.754 43.02h-4.117v2.877h4.117V43.02Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.057 46.19h-4.72v-3.474h4.723l-.003 3.473Zm-4.114-.609h3.51v-2.27h-3.51v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.282 43.02h-4.117v2.877h4.117V43.02Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.585 46.19H38.86v-3.474h4.724v3.473Zm-4.117-.609h3.51v-2.27h-3.51v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.757 45.806H3.282v4.124h42.475v-4.124Z",
    fill: "#585555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.06 50.23H2.98v-4.728h43.077l.003 4.729ZM3.59 49.624h41.865V46.11H3.589v3.513Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.387 52.352H6.271v2.878h4.116v-2.878Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.688 55.533h-4.72v-3.485h4.72v3.485Zm-4.114-.607h3.507v-2.27H6.574v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.915 52.352h-4.117v2.878h4.117v-2.878Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.215 55.533h-4.72v-3.485h4.72v3.485Zm-4.113-.607h3.507v-2.27h-3.507v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.833 52.352h-4.117v2.878h4.117v-2.878Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.136 55.533h-4.723v-3.485h4.723v3.485Zm-4.116-.607h3.51v-2.27h-3.51v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.754 52.352h-4.117v2.878h4.117v-2.878Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.057 55.533h-4.72v-3.485h4.723l-.003 3.485Zm-4.117-.607h3.51v-2.27h-3.507l-.003 2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.282 52.352h-4.117v2.878h4.117v-2.878Z",
    fill: "#9DDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.585 55.533H38.86v-3.485h4.724v3.485Zm-4.117-.607h3.51v-2.27h-3.51v2.27Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.757 55.138H3.282v4.124h42.475v-4.124Z",
    fill: "#585555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.06 59.56H2.98v-4.726h43.077l.003 4.726ZM3.59 58.952h41.865v-3.51H3.589v3.51Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.185.912H2.855v2.48h43.33V.911Z",
    fill: "#585555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.488 3.695H2.551V.608h43.937v3.087Zm-43.33-.608h42.723V1.215H3.158v1.872Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.488.608v3.087h-.7v4.47h.272v4.732h-.273V17.5h.273v4.732h-.273v4.603h.273v4.729h-.273v4.597h.273v4.732h-.273v4.603h.273v4.735h-.273v4.603h.273v4.726h-.273v1.443a1.332 1.332 0 0 1 .756.742 1.598 1.598 0 0 1 1.186 2.425 1.66 1.66 0 0 1-.47 2.905c.002.056.002.113 0 .17a1.676 1.676 0 0 1-1.262 1.62v4.463h-1.235v-.23h-2.206v.23h-1.122v-.23h-4.702v.303H12.299v-.303H4.074v.23H2.84v-4.652a1.659 1.659 0 0 1-.715-.857A1.656 1.656 0 0 1 .67 65.76a1.66 1.66 0 0 1 .48-.81 1.905 1.905 0 0 1 .91-2.871 1.328 1.328 0 0 1 1.189-1.149v-1.37h-.27v-4.726h.27v-4.603h-.27v-4.729h.27V40.9h-.27V36.16h.27v-4.597h-.27v-4.729h.27v-4.603h-.27V17.5h.27v-4.604h-.27v-4.73h.27v-4.47h-.698V.607h43.937ZM47.095 0H1.945v4.303h.697v3.254h-.27v5.947h.27v3.388h-.27v5.947h.27v3.389h-.27v5.943h.27v3.383h-.27V41.5h.27v3.389h-.27v5.95h.27v3.388h-.27v5.94h.27v.304a1.921 1.921 0 0 0-1.104 1.189 2.509 2.509 0 0 0-1.135 3.227A2.23 2.23 0 0 0 0 66.163a2.263 2.263 0 0 0 1.696 2.21c.138.243.32.46.537.637v4.941H4.68v-.23h7.01v.303h25.657v-.304h3.488v.231h2.336v-.23h.992v.23h2.448v-4.667a2.26 2.26 0 0 0 1.25-1.823A2.261 2.261 0 0 0 49 65.495a2.242 2.242 0 0 0-.54-1.471c.075-.222.113-.456.112-.69a2.212 2.212 0 0 0-1.629-2.127 1.976 1.976 0 0 0-.549-.562v-.478h.273v-5.94h-.273v-3.388h.273v-5.944h-.273v-3.389h.273v-5.952h-.273V32.17h.273v-5.943h-.273v-3.389h.273v-5.947h-.273v-3.388h.273V7.557h-.273V4.303h.7V0Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mansion_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h49v74H0z"
  })))));
};

export default SvgMansionIcon;